import * as React from 'react';

import { Card } from '../Card';

import { ICardItem, ISelectedPublication } from '../types';
import { IGetPublicationParams } from '../../../types/redux';
import * as styles from './styles.css';

interface IProps {
  content: [ICardItem, ICardItem];
  setSliderPause(isPaused: boolean): void;
  getPublication(payload: IGetPublicationParams): void;
  selectPublication(articleId: number): ISelectedPublication;
}

export const Slide: React.FC<IProps> = ({ content, setSliderPause, getPublication, selectPublication }) => {
  return (
    <div className={styles['container']}>
      {content.map(item => {
        return (
          <div key={item.id} className={styles['item']}>
            <Card
              {...item}
              setSliderPause={setSliderPause}
              getPublication={getPublication}
              selectPublication={selectPublication}
            />
          </div>
        );
      })}
    </div>
  );
};

Slide.displayName = 'Slide';
